/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Code_AppliedInputs */

const en_mobile_referral_code_applied = /** @type {(inputs: Mobile_Referral_Code_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral code applied`)
};

const es_mobile_referral_code_applied = /** @type {(inputs: Mobile_Referral_Code_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de referido aplicado`)
};

/**
* | output |
* | --- |
* | "Referral code applied" |
*
* @param {Mobile_Referral_Code_AppliedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_code_applied = /** @type {((inputs?: Mobile_Referral_Code_AppliedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Code_AppliedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_code_applied(inputs)
	return en_mobile_referral_code_applied(inputs)
});